module.exports = __webpack_public_path__ + "static/media/999715.095f5d14.png";